export default __webpack_public_path__ + "static/media/0x3ad707da309f3845cd602059901e39c4dcd66473.0d1744e7.webp";